// extracted by mini-css-extract-plugin
module.exports = {"stop":"_3bmbmJ5mV2SQ","stop__label":"_4X3OVvLN5LIb"};